/// <amd-module name="SuiteCommerce.Blog.Post.Header.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Header.View", ["require", "exports", "Backbone", "sc_blog_post_header.tpl", "SuiteCommerce.Blog.Post.Category.View", "SuiteCommerce.Blog.Post.Author.View", "SuiteCommerce.Blog.Post.Configuration"], function (require, exports, Backbone_1, headerTemplate, Post_Category_View_1, Post_Author_View_1, Post_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostHeaderView = /** @class */ (function (_super) {
        __extends(PostHeaderView, _super);
        function PostHeaderView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = headerTemplate;
            return _this;
        }
        Object.defineProperty(PostHeaderView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'Category.View': function () {
                        return new Post_Category_View_1.PostCategoryView({ model: _this.model });
                    },
                    'Author.View': function () {
                        return new Post_Author_View_1.PostAuthorView({ model: _this.model });
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        PostHeaderView.prototype.getContext = function () {
            return {
                header: this.model.header,
                publishingDate: this.model.publishingDate,
                publishedDateLabel: Post_Configuration_1.PostConfiguration.publishedDateLabel,
                subHeading: this.model.subHeading,
            };
        };
        return PostHeaderView;
    }(Backbone_1.View));
    exports.PostHeaderView = PostHeaderView;
});
